import React, { useContext } from "react";
import { Redirect } from "react-router-dom";
import Home from "../screens/Home";
import { GlobalContext } from "./GlobalContext";
const DashboardRoute = (props) => {

  //   const { state, setState } = useContext(GlobalContext);
  //   console.log("state!");
  const jwt = localStorage.getItem("id_token");
  const Component = props.component;
  return jwt ? (
    <Component params={props.computedMatch.params} />
  ) : (
    <Home />
  );
};

export default DashboardRoute;
